@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.generate-totes-canvas {
  background-color: var(--grey-100);
  display: flex;
  flex-direction: column;
}

.drawer-header-title {
  align-self: flex-start;

  .breadcrumbs-wrapper {
    align-items: center;
  }
}

.drawer-header {
  background: var(--grey-200);
}

.drawer-title {
  margin-top: @space-4;
  font-weight: 600;
}

.drawer-content-wrapper {
  flex-grow: 1;
  overflow-y: auto;
}

.drawer-footer {
  justify-content: space-between;
  align-items: center;
  padding: @space-24 @space-64;
  background-color: var(--white);
  border-top: 1px solid var(--grey-300);
}

.footer-right {
  gap: @space-12;
}

.separator {
  height: 16px;
  width: 16px;
  color: var(--grey-400);
  margin: @space-0 @space-8;
}
